// BELLA n' BEAR - sticky bar size proxy.
// This store's PDP uses a custom "ai-variant-picker" (spans, not radio inputs),
// so tapping a sticky size chip puppet-clicks the matching size label inside
// that picker - its own handler then updates the variant, price and URL, and
// the real Add to Cart button picks up the new selection. Falls back to the
// native Horizon <variant-picker> radio inputs if a product still uses them.
// Delegated from document so it survives the bar morphing/re-rendering.
(function () {
  function setActive(chip) {
    var group = chip.parentNode;
    if (!group) return;
    var chips = group.querySelectorAll('.bb-sticky-size');
    for (var i = 0; i < chips.length; i++) chips[i].classList.remove('is-active');
    chip.classList.add('is-active');
  }

  function selectNative(pid, ovid, value) {
    var picker =
      document.querySelector('variant-picker[data-product-id="' + pid + '"]') ||
      document.querySelector('variant-picker');
    if (!picker) return false;
    var input = null;
    if (ovid) input = picker.querySelector('input[data-option-value-id="' + ovid + '"]');
    if (!input && value) {
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if ((radios[i].value || '').trim() === value) { input = radios[i]; break; }
      }
    }
    if (!input) return false;
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function selectCustom(pid, value) {
    var container =
      document.querySelector('[class*="ai-variant-picker"][data-product-id="' + pid + '"]') ||
      document.querySelector('[class*="ai-variant-picker"]');
    if (!container) return false;
    var labels = container.querySelectorAll('[class*="ai-variant-picker__option-label"]');
    for (var i = 0; i < labels.length; i++) {
      if ((labels[i].textContent || '').trim() === value) {
        labels[i].click();
        return true;
      }
    }
    return false;
  }

  // Locate the custom picker's variant JSON (the data-variant-json-<id> script).
  // The id suffix is per-block, so we match by attribute-name prefix.
  var variantDataCache = null;
  function getVariantData() {
    if (variantDataCache) return variantDataCache;
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      var names = scripts[i].getAttributeNames();
      for (var j = 0; j < names.length; j++) {
        if (names[j].indexOf('data-variant-json-') === 0) {
          try { variantDataCache = JSON.parse(scripts[i].textContent); } catch (e) { variantDataCache = null; }
          return variantDataCache;
        }
      }
    }
    return null;
  }

  // Mirror the selected variant's availability onto the sticky ATC button so it
  // matches the PDP (disabled + "Sold out" when unavailable). Only the leading
  // text label is swapped; the quantity <span> is preserved.
  function setStickyAtcAvailability(host, available) {
    var atc = host.querySelector('.bb-sticky__atc');
    if (!atc) return;
    atc.disabled = !available;
    var label = available ? host.dataset.atcLabel : host.dataset.soldoutLabel;
    if (label) {
      var first = atc.firstChild;
      if (first && first.nodeType === 3) {
        first.nodeValue = label;
      } else {
        atc.insertBefore(document.createTextNode(label), atc.firstChild);
      }
    }
    host.dataset.variantAvailable = available ? 'true' : 'false';
  }

  // Look up the selected variant's availability and apply it to the sticky ATC.
  function syncStickyAtc(pid, variantId) {
    var data = getVariantData();
    var available = true;
    if (data && variantId != null && data[String(variantId)]) {
      available = data[String(variantId)].available !== false;
    }
    var hosts = document.querySelectorAll('sticky-add-to-cart');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      if (pid && host.dataset.productId && host.dataset.productId !== pid) continue;
      setStickyAtcAvailability(host, available);
    }
  }

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.bb-sticky-size');
    if (!chip) return;
    // Sold-out chips are intentionally tappable: selecting a sold-out size
    // mirrors the PDP (shows it selected and flips the ATC to "Sold out").

    var host = chip.closest('sticky-add-to-cart');
    if (!host) return;

    var pid = host.dataset.productId;
    var ovid = chip.dataset.optionValueId;
    var value = chip.dataset.optionValue;

    setActive(chip);
    if (!selectNative(pid, ovid, value)) {
      selectCustom(pid, value);
    }
  });

  // Reverse sync: when the MAIN picker changes the variant (including a sold-out
  // size tapped on the page), mirror the newly selected size onto the sticky
  // bar's active chip. The custom ai-variant-picker dispatches 'variant:changed'
  // on the window after it has set its own selected label, so we read that
  // label's text and activate the chip whose data-option-value matches - the
  // same matching the forward (chip -> picker) path relies on. Colour swatch
  // labels have no text content, so they never match a size chip.
  function syncStickyFromPicker(pid) {
    var hosts = document.querySelectorAll('sticky-add-to-cart');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      if (pid && host.dataset.productId && host.dataset.productId !== pid) continue;
      var chips = host.querySelectorAll('.bb-sticky-size');
      if (!chips.length) continue;

      var container =
        document.querySelector('[class*="ai-variant-picker"][data-product-id="' + pid + '"]') ||
        document.querySelector('[class*="ai-variant-picker"]');
      if (!container) continue;

      var selected = container.querySelectorAll('[class*="ai-variant-picker__option-label--selected"]');
      for (var s = 0; s < selected.length; s++) {
        var val = (selected[s].textContent || '').trim();
        if (!val) continue;
        for (var c = 0; c < chips.length; c++) {
          if ((chips[c].dataset.optionValue || '').trim() === val) {
            setActive(chips[c]);
            break;
          }
        }
      }
    }
  }

  window.addEventListener('variant:changed', function (event) {
    var pid = event.detail && event.detail.productId ? String(event.detail.productId) : null;
    var vid = event.detail && event.detail.variantId ? String(event.detail.variantId) : null;
    syncStickyFromPicker(pid);
    syncStickyAtc(pid, vid);
  });
})();
